import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const putQuery = (data) => {
  return apiRequestType(
    apiTypes.PUT,
    apiConstants.ADMIN.MY_QUERIES.PUT_Query(),
    data
  );
};

export default putQuery;
